import {EventBus} from "../../../../common/ts/events/EventBus";
import dom from "../../../../common/ts/core/dom";
import tracking from "../../../../common/ts/core/tracking";

import {FilterButtonClickedEvent, FiltersSubmittedEvent} from "./events";
import location from "../../../../common/ts/core/location";
import {FILTER_NAMES, FILTERS_BUTTON_SELECTOR, FILTERS_FORM_MODAL_SELECTOR} from "./constants";
import {MitulaSerpPageData} from "../SerpPage";
import {getFormDataSubmittingFromFiltersModal} from "./filterFormData";

const OPERATION_TYPE_BUTTON_SELECTOR = '#operation-type-filter';
const PROPERTY_TYPE_BUTTON_SELECTOR = '#property-type-filter';
const FREE_TEXT_BUTTON_SELECTOR = '#free-text-filter';
const PRICE_BUTTON_SELECTOR = '#price-filter';
const ROOMS_BUTTON_SELECTOR = '#rooms-filter';
const AREA_BUTTON_SELECTOR = '#area-filter';
const BATHROOMS_BUTTON_SELECTOR = '#bathrooms-filter';
const SORTING_BUTTON_SELECTOR = '#sorting-filter';
const AMENITIES_BUTTON_SELECTOR = '#amenities-filter';
const FILTER_BUTTON_SELECTORS: { [key: string]: string } = {
    [FILTER_NAMES.OPERATION_TYPE]: OPERATION_TYPE_BUTTON_SELECTOR,
    [FILTER_NAMES.PROPERTY_TYPE]: PROPERTY_TYPE_BUTTON_SELECTOR,
    [FILTER_NAMES.PRICE]: PRICE_BUTTON_SELECTOR,
    [FILTER_NAMES.ROOMS]: ROOMS_BUTTON_SELECTOR,
    [FILTER_NAMES.BATHROOMS]: BATHROOMS_BUTTON_SELECTOR,
    [FILTER_NAMES.AREA]: AREA_BUTTON_SELECTOR,
    [FILTER_NAMES.SORTING]: SORTING_BUTTON_SELECTOR,
    [FILTER_NAMES.AMENITIES]: AMENITIES_BUTTON_SELECTOR,
    [FILTER_NAMES.FREE_TEXT]: FREE_TEXT_BUTTON_SELECTOR,
};

let isOpen: boolean = false;
let eventBus: EventBus;
const filtersModal: HTMLElement = document.getElementById('serp-filters-modal')!;
const closeFiltersModalButton: HTMLElement = document.getElementById('close-serp-filters-modal')!;

function init(ev: any = EventBus.getInstance(), pageData: MitulaSerpPageData) {
    eventBus = ev;
    registerOpenModalListener();
    registerCloseModalListener();
    registerSubmitButtonFiltersListener(pageData);
}

function isModalOpen(): boolean {
    return isOpen;
}

function registerCloseModalListener() {
    if (closeFiltersModalButton) {
        closeFiltersModalButton.addEventListener('click', () => {
            filtersModal.classList.remove('displayed');
            document.body.style.overflow = 'auto';
            isOpen = false;
        })
    }
}

function openModalListener(filterName?: string) {
    isOpen = true;
    filtersModal.classList.add('displayed');
    document.body.style.overflow = 'hidden';
    eventBus.emit(new FilterButtonClickedEvent({filterName}))
    eventBus.emit(new tracking.TrackAnalyticsEvent({name: 'serp-search-bar-filters-button'}))
    eventBus.emit(new tracking.TrackWebTrackingEvent({type: "FiltersModalOpened", serpUrl: window.location.href}))
}

function registerOpenModalListener() {
    eventBus.emitMany(
        [
            new dom.AddClickListenerEvent({
                selector: FILTERS_BUTTON_SELECTOR,
                listener: () => openModalListener(),
            }),
            ...Object.values(FILTER_NAMES)
                .map(createEventListenerEventForFilter)
        ]
    )
}

function createEventListenerEventForFilter(filterName: string) {
    return new dom.AddClickListenerEvent({
        selector: FILTER_BUTTON_SELECTORS[filterName],
        listener: () => openModalListener(filterName),
    });
}



function registerSubmitButtonFiltersListener(pageData: MitulaSerpPageData) {
    dom.select(FILTERS_FORM_MODAL_SELECTOR)?.addEventListener('submit', (e: Event) => {
        e.preventDefault();

        const searchParams = new URLSearchParams(location.getQueryParams());
        if (pageData.operationType) searchParams.set("operationType", pageData.operationType);
        if (pageData.propertyType) searchParams.set("propertyType", pageData.propertyType);

        eventBus.emitMany([
            new FiltersSubmittedEvent({
                formData: getFormDataSubmittingFromFiltersModal(),
                searchParams,
                type: FiltersSubmittedEvent.MODAL_TYPE,
            }),
            new tracking.TrackWebTrackingEvent({
                type: "FiltersUpdated",
                serpUrl: window.location.href,
                filters: getTrackingModalFormData(getFormDataSubmittingFromFiltersModal(), searchParams, pageData.device),
            }),
        ]);
    });
}

function getTrackingModalFormData(
    formData: { [p: string]: any },
    currentSearchParams: URLSearchParams,
    device: string
) {
    const parsedFormData: { [key: string]: string } = {};

    if (device === "MOBILE") {
        if (formData["operationType"] && (formData["operationType"] !== currentSearchParams.get("operationType"))) {
            parsedFormData["operationType"] = formData["operationType"];
        }

        if (formData["propertyType"] && (formData["propertyType"] !== currentSearchParams.get("propertyType"))) {
            parsedFormData["propertyType"] = formData["propertyType"];
        }

        if (formData["minPrice"] && (formData["minPrice"] !== currentSearchParams.get("minPrice"))) {
            parsedFormData["minPrice"] = formData["minPrice"];
        }

        if (formData["maxPrice"] && (formData["maxPrice"] !== currentSearchParams.get("maxPrice"))) {
            parsedFormData["maxPrice"] = formData["maxPrice"];
        }

        if (formData["minBedrooms"] && (formData["minBedrooms"] !== currentSearchParams.get("minBedrooms"))) {
            parsedFormData["minBedrooms"] = formData["minBedrooms"];
        }

        if (formData["freeText"] && (formData["freeText"] !== currentSearchParams.get("freeText"))) {
            parsedFormData["freeText"] = formData["freeText"];
        }
    }

    if (formData["minBathrooms"] && (formData["minBathrooms"] !== currentSearchParams.get("minBathrooms"))) {
        parsedFormData["minBathrooms"] = formData["minBathrooms"];
    }

    if (formData["minArea"] && (formData["minArea"] !== currentSearchParams.get("minArea"))) {
        parsedFormData["minArea"] = formData["minArea"];
    }

    if (formData["maxArea"] && (formData["maxArea"] !== currentSearchParams.get("maxArea"))) {
        parsedFormData["maxArea"] = formData["maxArea"];
    }

    return parsedFormData;
}

export default {
    init,
    isModalOpen,
}